import AlertsPortalContainer from './AlertsPortalContainer';

export default AlertsPortalContainer;
